import { render, staticRenderFns } from "./PwRules.vue?vue&type=template&id=6b93ff91&scoped=true&"
import script from "./PwRules.vue?vue&type=script&lang=js&"
export * from "./PwRules.vue?vue&type=script&lang=js&"
import style0 from "./PwRules.vue?vue&type=style&index=0&id=6b93ff91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b93ff91",
  null
  
)

export default component.exports